const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
    tags: [],
    search: '',
    pageNo: 1,
    author: ''
};

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        tagSelected: (state, action) => {
            state.tags.push(action.payload);
        },
        tagRemoved: (state, action) => {
            const indexToRemove = state.tags.indexOf(action.payload);

            if (indexToRemove !== -1) {
                state.tags.splice(indexToRemove, 1);
            }
        },
        searched: (state, action) => {
            state.search = action.payload;
        },
        resetAllFilters: (state, action) => {
            state.tags = [];
            state.search = '';
            state.pageNo = 1;
            state.author = '';
        },
        setPageNo: (state, action) => {
            state.pageNo = action.payload;
        },
        resetPageNo: (state, action) => {
            state.pageNo = 1;
        },
        setAuthor: (state, action) => {
            state.author = action.payload;
            state.pageNo = 1;
            state.search = '';
            state.tags = [];
        },
        resetAuthor: (state, action) => {
            state.author = '';
            state.pageNo = 1;
        }
    }
});

export default filterSlice.reducer;
export const {
    tagSelected,
    tagRemoved,
    searched,
    setPageNo,
    resetAllFilters,
    resetPageNo,
    resetAuthor,
    setAuthor
} = filterSlice.actions;
